<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">Member Account Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <form-require-noti />
      <v-row>
        <v-col md="6">
          <label>User Name <require-sign /></label>
          <v-text-field
            v-model.trim="member.username"
            :error-messages="handleFieldErrors($v.member.username)"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col md="6">
          <label>Roles <require-sign /></label>
          <v-select
            v-model="member.role"
            outlined
            dense
            item-text="text"
            item-value="value"
            :items="roles"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6">
          <label>Projects</label>
          <v-select
            v-model="member.project"
            outlined
            dense
            item-text="text"
            item-value="value"
            :items="projects"
            :disabled="displayProject"
          ></v-select>
        </v-col>
        <v-col md="6">
          <label>Township Groups</label>
          <v-select
            v-if="!member.project || member.project == 2"
            v-model="member.township_group_id"
            outlined
            dense
            item-text="text"
            item-value="value"
            :items="mdr_townships"
            :disabled="displayTownship"
          ></v-select>
          <v-select
            v-else
            v-model="member.township_group_id"
            outlined
            dense
            item-text="text"
            item-value="value"
            :items="picts_townships"
            :disabled="displayTownship"
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn v-if="member.id" @click.prevent="emitDaData" class="form-btn">
        <v-icon left>mdi-edit</v-icon>
        Update
      </v-btn>
      <v-btn v-else @click.prevent="emitDaData" class="form-btn">
        <v-icon left>mdi-okay</v-icon>
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
import FormRequireNoti from "../notification/FormRequireNoti.vue";
import RequireSign from "@/components/notification/RequireSign.vue";

export default {
  components: { FormRequireNoti, RequireSign },

  mixins: [ValidationMixin],
  props: {
    member: {
      type: Object,
      default: () => {
        return {
          username: null,
          role: null,
          project: null,
          township_group_id: null,
        };
      },
    },
  },
  data: () => ({
    roles: [
      { value: 1, text: "PD" },
      { value: 2, text: "PO" },
      { value: 3, text: "MEAL MANAGER" },
      { value: 4, text: "MEAL OFFICER" },
      { value: 5, text: "PROGRAM MANAGER" },
      { value: 7, text: "CLINIC MANAGER" },
      { value: 6, text: "DPD" },
      "",
    ],
    projects: [{ value: 1, text: "PICTS" }, { value: 2, text: "MDR" }, ""],
    picts_townships: [
      { value: 1, text: "PICTS 1" },
      { value: 2, text: "PICTS 2" },
      "",
    ],
    mdr_townships: [
      { value: 1, text: "MDR 1" },
      { value: 2, text: "MDR 2" },
      "",
    ],
  }),
  validations: {
    member: {
      username: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    displayProject() {
      if (this.member.role)
        if (
          this.member.role == 2 ||
          this.member.role == 4 ||
          this.member.role == 5 ||
          this.member.role == 7 ||
          this.member.role == 6
        )
          return false;
      return true;
    },
    displayTownship() {
      if (this.member.role)
        if (this.member.role == 5 && this.member.project) return false;
      if (this.member.role == 7 && this.member.project) return false;
      return true;
    },
  },
  methods: {
    emitDaData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          username: this.member.username,
          role: this.member.role,
          project: this.member.project,
          township_group_id: this.member.township_group_id,
        };

        this.member.id ? (data.id = this.member.id) : false;

        this.$emit("emitDaData", data);

        this.$v.$reset();
      }
    },
  },
  created() {},
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
